function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { ViewerControlButtonDownload, ViewerControlsBox, ViewerControlButtonZoomIn, ViewerControlButtonZoomOut, ViewerControlButtonZoomRestore, ViewerControlFlagDarkBackground, ViewerControlButtonPositionRotate } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { Slug } from '@isyc-react/animation/modules/base/trail';
import clsx from 'clsx';
import { offsetHeightHeader, useArchiveLayoutDimensions } from "../../base/layout";
import '@isyc-react/design/main';
import "./view-image.style.scss";

// TODO implement onViewed callback

export const ViewImage = props => {
  const {
    dataUrl,
    name,
    scaleInitial = 1.0,
    scaleMin = 1.0,
    scaleMax = 8.0,
    onViewed
  } = props;
  const [dark, setDark] = React.useState(false);
  const [rotation, setRotation] = React.useState(0);
  const {
    layoutDim
  } = useArchiveLayoutDimensions(offsetHeightHeader, 0);
  const containerDims = React.useMemo(() => {
    const layoutWidth = rotation === 0 || rotation === 180 ? layoutDim.width : layoutDim.height;
    const layoutHeight = rotation === 0 || rotation === 180 ? layoutDim.height : layoutDim.width;
    return {
      height: `${layoutDim.height}px`,
      width: `${layoutDim.width}px`,
      maxHeight: `${layoutHeight}px`,
      maxWidth: `${layoutWidth}px`
    };
  }, [layoutDim, rotation]);
  const isSvg = React.useMemo(() => dataUrl.includes('image/svg+xml'), [dataUrl]);
  const baseImgDims = React.useMemo(() => {
    if (isSvg) return undefined;
    return {
      height: 'auto',
      width: 'auto'
    };
  }, [isSvg]);
  React.useEffect(() => {
    onViewed && onViewed();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TransformWrapper, null, ({
    zoomIn,
    zoomOut,
    resetTransform,
    centerView,
    state,
    instance
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-image-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-image-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlFlagDarkBackground, {
    flag: dark,
    onChange: setDark
  }), /*#__PURE__*/React.createElement(ViewerControlButtonZoomIn, {
    disabled: state.scale >= scaleMax,
    zoomIn: zoomIn
  }), /*#__PURE__*/React.createElement(ViewerControlButtonZoomOut, {
    disabled: state.scale <= scaleMin,
    zoomOut: zoomOut
  }), /*#__PURE__*/React.createElement(ViewerControlButtonZoomRestore, {
    disabled: state.scale === scaleInitial,
    zoomRestore: resetTransform
  }), /*#__PURE__*/React.createElement(ViewerControlButtonPositionRotate, {
    rotation: rotation,
    onRotate: setRotation
  }), /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      dataUrl
    },
    name: name
  }))), /*#__PURE__*/React.createElement(Slug, {
    delay: 0,
    from: {
      opacity: 0,
      transform: 'translate3d(0,-40px,0)'
    },
    className: 'w-100 h-100'
  }, /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-image-document"
  }, /*#__PURE__*/React.createElement(TransformComponent, {
    wrapperClass: "viewer-grab-scrollable w-100 h-100",
    contentClass: "w-100 h-100 justify-content-center"
    // contentStyle={containerDims}
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('view-image-image', {
      dark
    }),
    style: containerDims
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: dataUrl,
    className: "view-image-inner",
    style: _objectSpread(_objectSpread(_objectSpread({}, containerDims), baseImgDims), {}, {
      transform: `rotate(${rotation}deg)`
    })
  })))))))))));
};